<template>
    <div class="posts">
        <div v-for="(post, index) in displayedPosts" :key="index" class="post">
            <PostArticle v-if="post.title" :post="post" :search-queries="searchQueries" :category-id="categoryId" />
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import DiscussionPost from '~/models/DiscussionPost'
import PostArticle from '~/components/objects/Discussion/Posts/PostArticle.vue'
import Post from '~/models/Discussion/Post'

export default {
    components: {
        PostArticle,
    },
    props: {
        posts: {
            type: [] as PropType<DiscussionPost[]>,
            default: null,
            required: true,
        },
        showAnswer: {
            type: Boolean,
            default: false,
        },
        searchQueries: {
            type: Array,
            default: null,
            required: false,
        },
        categoryId: {
            type: Number,
            default: null,
            required: false,
        },
    },
    data() {
        return {
            displayedPosts: [] as DiscussionPost[],
            displayedPostsAnswers: [],
        }
    },
    computed: {
        showPost(post: DiscussionPost, typePost = 'post') {
            return (post.isShown && post.isPublished) || typePost === 'answer'
        },
    },
    created() {
        this.displayedPosts = [...this.posts]
    },
    beforeCreate() {
        useNuxtApp().$bus.$on('toggleAnswerList', (postId: number) => {
            const post = this.findPostById(postId)
            if (post) {
                post.isAnswerListHidden = !post.isAnswerListHidden
            }
        })

        useNuxtApp().$bus.$on('toggleRespond', (postId: number) => {
            const post = this.findPostById(postId)

            if (post) {
                post.isUserResponding = !post.isUserResponding
            }
        })
    },
    methods: {
        findPostById(id: number) {
            let foundPost = this.displayedPosts.find((p: DiscussionPost) => p.id === id)
            if (!foundPost) {
                for (const post of this.displayedPosts) {
                    if (post.answers) {
                        foundPost = post.answers.find((a: Post) => a.id === id)
                        if (foundPost) {
                            break
                        }
                    }
                }
            }
            return foundPost
        },
    },
}
</script>

<style lang="scss" scoped>
.post {
    @include screen-md {
        box-shadow: $box-shadow;
        border-radius: 10px;
    }

    &__hr {
        border-top: 0 solid $color-grey-dark;
    }
}
</style>
